/* eslint-disable no-unused-vars */
import React from "react";
import * as styles from "./ProjectSynopsis.module.css";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";

function ProjectSynopsis() {
  return (
    <div className={styles.projectSynopsis} id="project-synopsis">
      <div className={styles.projectSynopsisContainer}>
        <div className={styles.projectSynopsisContent}>
          <h1>
            <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
            Project Synopsis
          </h1>
          <p>
            A honest, tangible pursuit to create a tranquil haven in the midst
            of Chennai’s new metro centre sets this development apart. The
            design intent is to reinvent and redefine high-rise living
            standards. The result is a tranquil, oceanfront natural haven that
            vibrantly blends modern architecture with innovative landscaping.
            Private outdoor sanctuaries adorn the periphery of each tower. Every
            residence’s living room or bedroom is strategically oriented with
            uninterrupted access to stunning vistas of the ocean. This ensures
            one block’s residents’ view isn’t obstructed by the other.
          </p>
        </div>
      </div>
    </div>
  );
}
export default ProjectSynopsis;
